import React,{ useState, useEffect, Fragment } from 'react'
import AllVerification from '../../component/AllVerification';
import { Box } from '@chakra-ui/react';
import { Auth } from '../../component/Auth';
import axios from 'axios'
function VerificationAll() {
    // const [tData, setTData] = useState([]);
    const [orderData, setOrderData] = useState([])
    const [isLoading, setIsLoading] = useState({loading: true, error: false})


  // useEffect(() => {
  //   const fetchData = async () => {
  //     let response = await fetch('http://localhost:3000/customer-verification-all');
  //     let data = await response.json();
  //     setTData(data);
  //   }
  //   fetchData()
  // }, [])

  useEffect(() => {
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order`,
      headers: { 
        'Authorization': Auth()
    }
  }

    axios.request(config)
    .then((response) => {
      setOrderData(response.data)
      setIsLoading({loading: false, error: false})

    })
    .catch((error) => {
      console.log(error);
      setIsLoading({loading: false, error: true})
    });
  },[])


  return (
    <Fragment>
      <Box p={5} flex="1" w={'100%'} >
    <AllVerification 
      title={'All Verifications'}
      head={["Order", "Date", "Customer Name", "Customer Status", "Verification Status", ""]}
      data={orderData}
      isLoading={isLoading}
      />
     </Box>
    </Fragment>
  )
}

export default VerificationAll